/// <reference types="./extra.d.mts" />
import * as $json from "../../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $float from "../../../../gleam_stdlib/gleam/float.mjs";
import * as $duration from "../../../../gleam_time/gleam/time/duration.mjs";
import { divideFloat } from "../../../gleam.mjs";

export function to(duration, unit) {
  let duration$1 = $duration.to_seconds(duration);
  if (unit instanceof $duration.Nanosecond) {
    return duration$1 * 1_000_000_000.0;
  } else if (unit instanceof $duration.Microsecond) {
    return duration$1 * 1_000_000.0;
  } else if (unit instanceof $duration.Millisecond) {
    return duration$1 * 1000.0;
  } else if (unit instanceof $duration.Second) {
    return duration$1;
  } else if (unit instanceof $duration.Minute) {
    return divideFloat(duration$1, 60.0);
  } else if (unit instanceof $duration.Hour) {
    return divideFloat(duration$1, 3600.0);
  } else if (unit instanceof $duration.Day) {
    return divideFloat(duration$1, 86_400.0);
  } else if (unit instanceof $duration.Week) {
    return duration$1 * 604_800.0;
  } else if (unit instanceof $duration.Month) {
    return divideFloat(duration$1, 2_629_800.0);
  } else {
    return divideFloat(duration$1, 31_557_600.0);
  }
}

export function blur_to(duration, unit) {
  let duration$1 = to(duration, unit);
  return $float.round(duration$1);
}

export function days(n) {
  return $duration.hours(24 * n);
}

export function weeks(n) {
  return $duration.hours(24 * 7 * n);
}

export function months(n) {
  return $duration.hours(24 * 30 * n);
}

export function years(n) {
  return $duration.hours(24 * 365 * n);
}

export function unit_to_seconds(unit) {
  if (unit instanceof $duration.Nanosecond) {
    return 0;
  } else if (unit instanceof $duration.Microsecond) {
    return 0;
  } else if (unit instanceof $duration.Millisecond) {
    return 0;
  } else if (unit instanceof $duration.Second) {
    return 1;
  } else if (unit instanceof $duration.Minute) {
    return 60;
  } else if (unit instanceof $duration.Hour) {
    return 3600;
  } else if (unit instanceof $duration.Day) {
    return 86_400;
  } else if (unit instanceof $duration.Week) {
    return 604_800;
  } else if (unit instanceof $duration.Month) {
    return 2_629_800;
  } else {
    return 31_557_600;
  }
}

export function encode_unit(unit) {
  if (unit instanceof $duration.Nanosecond) {
    return $json.string("nanosecond");
  } else if (unit instanceof $duration.Microsecond) {
    return $json.string("microsecond");
  } else if (unit instanceof $duration.Millisecond) {
    return $json.string("millisecond");
  } else if (unit instanceof $duration.Second) {
    return $json.string("second");
  } else if (unit instanceof $duration.Minute) {
    return $json.string("minute");
  } else if (unit instanceof $duration.Hour) {
    return $json.string("hour");
  } else if (unit instanceof $duration.Day) {
    return $json.string("day");
  } else if (unit instanceof $duration.Week) {
    return $json.string("week");
  } else if (unit instanceof $duration.Month) {
    return $json.string("month");
  } else {
    return $json.string("year");
  }
}

export function unit_decoder() {
  return $decode.then$(
    $decode.string,
    (period) => {
      if (period === "day") {
        return $decode.success(new $duration.Day());
      } else if (period === "hour") {
        return $decode.success(new $duration.Hour());
      } else if (period === "month") {
        return $decode.success(new $duration.Month());
      } else if (period === "week") {
        return $decode.success(new $duration.Week());
      } else if (period === "year") {
        return $decode.success(new $duration.Year());
      } else if (period === "microsecond") {
        return $decode.success(new $duration.Microsecond());
      } else if (period === "millisecond") {
        return $decode.success(new $duration.Millisecond());
      } else if (period === "minute") {
        return $decode.success(new $duration.Minute());
      } else if (period === "nanosecond") {
        return $decode.success(new $duration.Nanosecond());
      } else if (period === "second") {
        return $decode.success(new $duration.Second());
      } else {
        return $decode.failure(new $duration.Year(), "Unit");
      }
    },
  );
}
